// extracted by mini-css-extract-plugin
module.exports = {"customStyle":"index_customStyle_2Ln2n"};